import moment from 'moment'
import React from 'react'
import ICON from '../../assets/logos/icon.png'

function Footer() {
  return (
    <footer className="bg-[#1A1D20] rounded-lg shadow dark:bg-gray-900 m-4">
      <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
        <div className="sm:flex sm:items-center sm:justify-between">
          <a href="https://flowbite.com/" className="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse no-underline">
            <img src={ICON} className="h-10" alt="Flowbite Logo" />
            <span className="self-center text-2l font-semibold whitespace-nowrap text-white no-underline">Live on Beat</span>
          </a>
          <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
            <li>
              <a href="#1" className="no-underline me-4 md:me-6 text-gray-500">About</a>
            </li>
            <li>
              <a href="#1" className="no-underline me-4 md:me-6 text-gray-500">Privacy Policy</a>
            </li>
            <li>
              <a href="#1" className="no-underline me-4 md:me-6 text-gray-500">Licensing</a>
            </li>
            <li>
              <a href="#1" className="no-underline text-gray-500">Contact</a>
            </li>
          </ul>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© {moment().format('YYYY')} <a href="https://flowbite.com/" className="no-underline">Flowbite™</a>. All Rights Reserved.</span>
      </div>
    </footer>
  )
}

export default Footer